export default __webpack_public_path__ + "static/media/Gonzalo Longo Elia.8e8742e1.jpg";